module.exports = __webpack_public_path__ + "assets/img/ic-intro-cake.e1ce48cf.png";